import { createFFmpeg, fetchFile } from "@ffmpeg/ffmpeg";

// 获取文件地址
function getObjectURL(file: File) {
  let url = null;
  window.URL = window.URL || window.webkitURL;
  if (window.URL) {
    url = window.URL.createObjectURL(file);
  } else {
    url = URL.createObjectURL(file);
  }
  return url;
}

// 视频压缩处理类
export default class Ffmpeg {
  file: File;
  fileName: string;
  fileType: string;
  videoWidth: number;
  videoHeight: number;
  fileDuration: number;
  progressCallback: (progressObj: any) => void;
  compressRatio: number;
  constructor(
    file: File,
    options: {
      onProgress?: (progress: number) => void;
      compressRatio?: number;
    }
  ) {
    console.log("create Ffmpeg instance file: ", file);
    this.file = file;
    // 文件名（编码，防止中文报错）
    this.fileName = encodeURIComponent(file.name);
    // 文件类型
    this.fileType = file.type;
    // 视频宽
    this.videoWidth = 0;
    // 视频高
    this.videoHeight = 0;
    // 视频时长
    this.fileDuration = 0;

    // 压缩进度回调函数
    this.progressCallback =
      options.onProgress ||
      function (data) {
        console.log("压缩进度：", data);
      };
    // 压缩比例
    this.compressRatio = options.compressRatio || 0.5;
    // 检查是否是视频文件
    if (!this._checkFileType()) {
      throw new Error("FfmpegClass constructor: file is not a video file");
    }
  }

  _checkFileType() {
    return this.fileType.startsWith("video/");
  }

  // 获取视频信息
  _getInfo() {
    return new Promise((resolve, reject) => {
      const videoElement = document.createElement("video");
      videoElement.preload = "metadata";
      const _this = this;

      videoElement.onloadedmetadata = function () {
        console.log("this:", this);
        const videoElThis = this as HTMLVideoElement;
        const width = (_this.videoWidth = videoElThis.videoWidth);
        const height = (_this.videoHeight = videoElThis.videoHeight);
        const duration = (_this.fileDuration = videoElThis.duration);
        resolve({ width, height, duration });
      };

      videoElement.onerror = function () {
        reject(new Error("Error loading video metadata"));
      };

      videoElement.src = getObjectURL(this.file);
    });
  }

  // 获取压缩后文件大小
  _getCompressedFileSize() {
    const fileSize = this.file.size;
    const ratio = this.compressRatio;
    // 压缩后的文件大小
    const compressedFileSize = fileSize * ratio;
    // 转换成 M，只保留整数
    const compressedFileSizeM = parseInt(
      (compressedFileSize / 1024 / 1024).toFixed(0)
    );
    console.log("获取生成后文件大小：", fileSize, ratio, compressedFileSizeM);
    return `${compressedFileSizeM}M`;
  }

  // 压缩视频
  _compress() {
    // 实例化ffmpeg
    const ffmpegObj = createFFmpeg({
      // ffmpeg路径
      corePath: "ffmpeg-core.js",
      // 日志
      log: true,
      // 进度
      progress: this.progressCallback,
    });
    // 临时压缩输出文件名（带上时间戳）
    const tempOutputfileName = `output_${Date.now()}.mp4`;
    return ffmpegObj
      .load()
      .then(() => fetchFile(this.file))
      .then((fetchFileRes: any) => {
        ffmpegObj.FS("writeFile", this.fileName, fetchFileRes);
        return ffmpegObj.run(
          "-i",
          this.fileName,
          "-b", // -b：指定视频比特率
          "2000000",
          "-crf", // -crf：恒定速率因子，控制输出视频质量的参数。这个参数的取值范围为0~51，其中0为无损模式。数值越大，画质越差，生成的文件却越小。从主观上讲，18~28是一个合理的范围。18被认为是视觉无损的（从技术角度上看当然还是有损的），它的输出视频质量和输入视频相当
          "18",
          "-fs", // -fs：压缩到指定大小，单位Byte
          this._getCompressedFileSize() as any, // 压缩后的视频大小
          "-s", // -s：分辨率
          `${this.videoWidth}x${this.videoHeight}`,
          tempOutputfileName // 输出文件名
        );
      })
      .then(() => {
        // 压缩所完成，   读文件  压缩后的文件名称为 output.mp4
        const data = ffmpegObj.FS("readFile", tempOutputfileName);
        console.log("压缩完成data：", data);
        // 转换bolb类型
        const blob = new Blob([data], { type: "text/plain;charset=utf-8" });
        return new Promise((resolve) => {
          const file = new File([blob], this.fileName, { type: this.fileType });
          resolve(file);
        });
      });
  }

  // 执行压缩
  compress() {
    return Promise.resolve()
      .then(() => this._getInfo())
      .then(() => this._compress())
      .catch((err) => {
        console.error("视频压缩失败：", err);
      });
  }
}
